import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import styled from 'styled-components';
import { CardWordList } from '../../../asset/utils/CardWordList';
import { ContentBookPath } from '../../../asset/utils/Constant';
import { setSlide } from '../../../store/CardSlice';
import { Button } from '../../_atoms/Button';
import { Item } from '../../_atoms/Item';
import { List } from '../../_atoms/List';
import { CardList } from '../../_molecules/CardList';

const StyledSlider = styled(Slider)`
  width : 100%;

  .slick-list {
    width : 100%;
    height: 100%;
  }

  .slick-track {
    display: flex;
    height: 100%;
  }

  .slick-slide {
    width : 100%;
    height : 100%;

    div {
      width : 100%;
      height : 100%;
    }
  }

  .slick-prev.slick-disabled {
    background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/flashCard/fc_prev_off.png);
  }
  
  .slick-next.slick-disabled {
    background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/flashCard/fc_next_off.png);
  }

  .slick-dots li {
    width : 10px;
    height: 10px;
  }

  .slick-dots .slick-active li {
    background-color: #888;
  }
`;

export const CardSliderWrap = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const slider = useRef();

  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const slideArray = (CardWordList[state.book.current_book][state.card.unit].word).map((slide, idx) => {
      return (
        slide.map((word, i) => ({
          word : word,
          act : false,
          choice : false,
          back : false,
          reset : false,
          src : ContentBookPath + (state.book.current_book + 1) + '/flashCard/b' + (state.book.current_book + 1) + '-unit' + CardWordList[state.book.current_book][state.card.unit].unit + '-' + word + '_optimized.png',
          wsrc : ContentBookPath + (state.book.current_book + 1) + '/flashCard/b' + (state.book.current_book + 1) + '-unit' + CardWordList[state.book.current_book][state.card.unit].unit + '-w-' + word + '_optimized.png',
        }))
      )
    });

    dispatch(setSlide(slideArray));

    if (CardWordList[state.book.current_book][state.card.unit].word.length - 1 === activeSlide) {
      setTimeout(() => {
        slider.current.slickGoTo(0);
      }, 600)
    } else {
      slider.current.slickGoTo(0);
    }
  }, [state.card.unit]);

  const settings = {
    dots : true,
    infinite : false,
    speed : 500,
    slidesToScroll : 1,
    nextArrow : <Button type="slide" value="next" disabled={state.card.word_play}/>,
    prevArrow : <Button type="slide" value="prev" disabled={state.card.word_play}/>,
    appendDots : dots => (
      <List order={false} type="dots">
        {dots}
      </List>
    ), 
    customPaging : i => (
      <Item type="dots"></Item>
    ),
    beforeChange : (next) => {
      setActiveSlide(next);
    }
  };

  return (
    <StyledSlider {...settings} ref={slider}>
      {state.card.slide && state.card.slide.map((card, idx) => {
        return (
          <CardList card={card} idx={idx}/>
        );
      })}
    </StyledSlider>
  );
};